var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SearchField } from '@purpurds/purpur/search-field';
import styled from 'styled-components';
const StyledSearchWrapper = styled.div `
  ${({ isFullWidth }) => isFullWidth && 'width: 100%;'}
`;
export const SearchInputField = (_a) => {
    var { fullWidth = true } = _a, props = __rest(_a, ["fullWidth"]);
    return (_jsx(StyledSearchWrapper, { isFullWidth: fullWidth, children: _jsx(SearchField, Object.assign({}, props)) }));
};
